export const BOW_TIE_SIDE = {
  PREVENTIVO: 'preventive',
  CORRETIVO: 'corrective',
};

export const BOW_TIE_BORDER_COLOR = {
  cause: 'tw:border-[#0d6efd]',
  consequence: 'tw:border-[#dc3545]',
  [BOW_TIE_SIDE.PREVENTIVO]: 'tw:border-[#2b9fad]',
  [BOW_TIE_SIDE.CORRETIVO]: 'tw:border-[#de922f]',
};

export const BOW_TIE_HORIZONTAL_LINE =
  'tw:pointer-events-none tw:absolute tw:top-1/2 tw:h-px tw:bg-[#dfe7ef]';
